<template>
	<el-tabs v-model="activeName">
		<el-tab-pane label="入库" name="op">
			<div class="content-box">
				<edit-in-bound type="inbound"></edit-in-bound>
			</div>
		</el-tab-pane>
		<el-tab-pane label="入库记录" name="his">
			<his v-if="activeName=='his'" :type="[21]"></his>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import TabPage from "@/mixins/TabPage.js";
import His from "@/views/Inventory/subs/His.vue";
import EditInBound from "@/views/Inventory/subs/EditInbound";

export default {
	mixins: [TabPage],
	components: {
		His,
		EditInBound
	},
	data() {
		return {
			activeName: "op"
		};
	}
};
</script>
<style lang="scss" scoped>
</style>
